import ImpressionTimer from "@components/impression-timer/ImpressionTimer";
import { usePostAdClickMutation } from "@mwServices/Ads";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

interface CustomAdProps {
    campaignUrl: string;
    adId: number;
    imageUrl: string;
    displayOn: string[];
    sticky: boolean;
}

const CustomAd = ({ campaignUrl, adId, imageUrl, sticky, displayOn }: CustomAdProps) => {
    const [postAdClick, postAdClickResponse] = usePostAdClickMutation();

    return (
        <ImpressionTimer adId={adId} sticky={sticky}>
            <Row
                className={'custom-ad' + (displayOn.includes('mobile') ? '' : ' height-defined')}
                justify={'center'}
                align={'middle'}>
                <Col>
                    <Link
                        to={`${campaignUrl}`}
                        target="_blank"
                        onClick={() => {
                            postAdClick(adId);
                        }}>
                        <img src={imageUrl} />
                    </Link>
                </Col>
            </Row>
        </ImpressionTimer>
    );
}

export default CustomAd;